<div class="flex flex-col justify-start items-center">
  <!--  <div class="text-light-gray"></div>-->
  @if (state === 'analysing' || state === 'start') {
    <svg class="w-full" id="Ebene_1" viewBox="0 0 283.46 283.46" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m141.73,0C63.46,0,0,63.46,0,141.73s63.46,141.73,141.73,141.73,141.73-63.46,141.73-141.73S220.01,0,141.73,0Zm0,245.67c-57.4,0-103.94-46.53-103.94-103.94s46.53-103.94,103.94-103.94,103.94,46.53,103.94,103.94-46.53,103.94-103.94,103.94Z"
        style="fill:#d9d9d9;"/>
      @if (state === 'start') {
        <ng-container>
          <circle [style.stroke-dashoffset]="calculateDashOffset()" class="stroke-[#111928]" cx="141.73" cy="141.73"
                  id="circle" r="122.94"/>
        </ng-container>
      }
      @if (state === 'analysing') {
        <ng-container>
          <circle [style.stroke-dashoffset]="calculateDashOffset()" class="stroke-[#111928]" cx="141.73"
                  cy="141.73" id="circleRotate" r="122.94"/>
        </ng-container>
      }
    </svg>
  }

  @if (state === 'ready') {
    <fa-icon [icon]="faCircleCheck" class="text-gray-300 scale-150"></fa-icon>
  }

  @if (state === 'checked') {
    <fa-icon [icon]="faCircleCheck" class="text-green scale-150"></fa-icon>
  }

  @if (state === 'error') {
    <fa-icon [icon]="faCircleXmark" class="text-red-500 scale-150"></fa-icon>
  }

</div>


